import { type RouteObject, createBrowserRouter } from 'react-router-dom';

import { RootLayout } from '@/app/layouts/RootLayout';

const routes: RouteObject[] = [
  {
    children: [
      {
        index: true,
        lazy: async () => import('./ExplorerRoute'),
      },
      {
        lazy: async () => import('./BossDemoRoute'),
        path: 'demo',
      },
      {
        lazy: async () => import('./ContractWorkbenchRoute'),
        path: 'contract',
      },
      {
        lazy: async () => import('./LoadTestRoute'),
        path: 'load-test',
      },
      {
        lazy: async () => import('./QueryConsoleRoute'),
        path: 'query',
      },
      {
        lazy: async () => import('./NlQueryAssistantRoute'),
        path: 'assistant',
      },
      {
        lazy: async () => import('./ProofLifecycleRoute'),
        path: 'proofs',
      },
      {
        lazy: async () => import('./TraceExplorerRoute'),
        path: 'trace',
      },
      {
        lazy: async () => import('./DocsRoute'),
        path: 'docs/*',
      },
    ],
    element: <RootLayout />,
    path: '/',
  },
  {
    lazy: async () => import('./NotFoundRoute'),
    path: '*',
  },
];

export const appRouter = createBrowserRouter(routes);
